/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */import { defineMessages } from 'react-intl';

 export default defineMessages({
  Utils_Provider_Search_Combo_Box_Manual_Option: {
    id: 'Utils_Provider_Search_Combo_Box_Manual_Option',
    defaultMessage: 'Provider not found. Please enter valid provider name.',
  },
  Utils_Provider_Search_API_Error_Generic: {
    id: 'Utils_Provider_Search_API_Error_Generic',
    defaultMessage: 'Error on search api',
  },
  Utils_Provider_Search_API_Error_No_Records: {
    id: 'Utils_Provider_Search_API_Error_No_Records',
    defaultMessage: 'Error on search api, no records found',
  },
});